function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import React, { useState } from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- replace with crystal-ui
import { TextField, Typography, makeStyles } from '@applyboard/ui-components';
import ErrorMessage from "../ErrorMessage";
var useStyles = makeStyles({
  label: {
    '& label': {
      top: '-5px'
    }
  }
});
var ScoreInput = function ScoreInput(props) {
  var label = props.label,
    exam = props.exam,
    name = props.name,
    value = props.value,
    onChange = props.onChange,
    _props$section = props.section,
    section = _props$section === void 0 ? '' : _props$section,
    showError = props.showError,
    errorMessage = props.errorMessage;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    bluredAndError = _useState2[0],
    setBluredAndError = _useState2[1];
  var error = (showError || bluredAndError) && !!errorMessage;
  var classes = useStyles();
  var onBlur = function onBlur() {
    setBluredAndError(!!errorMessage);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextField, {
    id: "".concat(exam, "-").concat(label, "-").concat(name),
    name: name,
    label: /*#__PURE__*/React.createElement(Typography, {
      variant: "paragraph"
    }, label),
    variant: "outlined",
    error: error,
    value: value,
    onChange: onChange,
    className: classes.label,
    inputProps: {
      'aria-label': "".concat(exam, " ").concat(section, " ").concat(label)
    },
    fullWidth: true,
    autoComplete: "off",
    onBlur: onBlur
  }), error && /*#__PURE__*/React.createElement(ErrorMessage, {
    message: errorMessage
  }));
};
export default ScoreInput;